import { NamedChartComponent, WAITING_DAYS_DONUT_LABELS, appendTimingQueryParams, waitingDaysBucketToTimingQueryParams } from '@frontend/chart/components';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { StatisticsCard, waitingDaysLabelFormatter } from '../shared';
import { usePudoTransactionTimerWaitingDaysDonut } from './use-pudo-transaction-timer-waiting-days-donut';

export interface PudoTransactionTimerWaitingDaysStackedBarCardProps {
    accountId: string;
    navigateUrl?: string;
    title: React.ReactNode;
    Chart: NamedChartComponent;
}

export const PudoTransactionTimerWaitingDaysStackedBarCard = ({ accountId, navigateUrl, title, Chart }: PudoTransactionTimerWaitingDaysStackedBarCardProps) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const { data, isLoading, total, hasData } = usePudoTransactionTimerWaitingDaysDonut(accountId, Chart.definition);
    const segmentLabels = WAITING_DAYS_DONUT_LABELS.map((label) => waitingDaysLabelFormatter(label, intl));

    const onSegmentClick = navigateUrl
        ? (bucketLabel: string) => {
              navigate(appendTimingQueryParams(navigateUrl, waitingDaysBucketToTimingQueryParams(bucketLabel)));
          }
        : undefined;

    return (
        <StatisticsCard
            chartKey={Chart.definition.key}
            title={title}
            subtitle={total}
            isLoading={isLoading}
            hasData={hasData}>
            {data && (
                <div className='min-h-0 w-full min-w-0'>
                    <Chart
                        data={data}
                        segmentLabels={segmentLabels}
                        onSegmentClick={onSegmentClick}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
